import cx from 'classnames';

import {Icon, Tooltip} from 'components';

type Props = {
    header?: string;
    message: string;
    className?: string;
    children?: React.ReactNode
}

export const Information = ({message, header, className, children}: Props) => (
    <div className='tw-flex'>
        <Tooltip
            header={header}
            message={message}
            className='tw-items-center tw-justify-center'
            style={{display: 'flex'}}
        >
            <Icon name='info' className={cx('tw-mx-1', className)} />
        </Tooltip>
        {children}
    </div>
);